import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
    Card,
    CardHeader,
    CardContent,
    Divider,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography
} from '@material-ui/core';
import { StatusArrow } from 'components';
import { currencyKr } from 'helpers/currencyKr';

const useStyles = makeStyles(theme => ({
    root: {},
    header: {},
    content: {
        padding: 0
    },
    table: {
        [theme.breakpoints.down('md')]: {
            tableLayout: 'fixed'
        }
    },
    td: {
        textAlign: 'center',
        padding: '10px 2px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    statusContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    status: {
        marginRight: theme.spacing(1)
    },
    up: {
        color: theme.palette.error.main
    },
    down: {
        color: theme.palette.info.main
    },
    middle: {
        marginLeft: theme.spacing(-1),
        color: theme.palette.black
    },
    caption: {
        marginLeft: theme.spacing(1)
    }
}));

const TodayRanking = props => {
    const { className, data, ...rest } = props;

    console.log(data);

    const classes = useStyles(props);

    return (
        <>
            <Card {...rest} className={clsx(classes.root, className)}>
                <CardHeader
                    title="Today's Ranking"
                    className={classes.header}
                />
                <Divider />
                <CardContent className={classes.content}>
                    <Grid container spacing={1}>
                        {data.map((ranking, i) => (
                            <Grid key={i} item lg={6} md={6} xs={12}>
                                <Table className={classes.table}>
                                    <colgroup>
                                        <col className={classes.colRanking} />
                                        <col className={classes.colPlatform} />
                                        <col className={classes.colPoint} />
                                        <col className={classes.colChange} />
                                    </colgroup>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                colSpan={4}
                                                className={classes.td}>
                                                <strong>
                                                    {ranking.category}
                                                </strong>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell
                                                size="small"
                                                className={classes.td}>
                                                Rank
                                            </TableCell>
                                            <TableCell className={classes.td}>
                                                Name
                                            </TableCell>
                                            <TableCell className={classes.td}>
                                                Revenue
                                            </TableCell>
                                            <TableCell className={classes.td}>
                                                Diff
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {ranking.data.map((data, j) => (
                                            <TableRow hover key={j}>
                                                <TableCell
                                                    className={classes.td}>
                                                    {data.ranking}
                                                </TableCell>
                                                <TableCell
                                                    className={classes.td}
                                                    title={data.platform}>
                                                    {data.platform}
                                                </TableCell>
                                                <TableCell
                                                    className={classes.td}>
                                                    {currencyKr(data.point)}
                                                </TableCell>
                                                <TableCell
                                                    className={classes.td}>
                                                    <div
                                                        className={
                                                            classes.statusContainer
                                                        }>
                                                        <StatusArrow
                                                            className={
                                                                classes.status
                                                            }
                                                            size="sm"
                                                            type={
                                                                data.change
                                                                    .status
                                                            }
                                                        />
                                                        <Typography
                                                            className={
                                                                classes[
                                                                    data.change
                                                                        .status
                                                                ]
                                                            }
                                                            variant="body2">
                                                            {data.change
                                                                .ranking === '-'
                                                                ? null
                                                                : data.change
                                                                      .ranking}
                                                        </Typography>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Grid>
                        ))}
                    </Grid>
                </CardContent>
                <Divider />
            </Card>
        </>
    );
};

TodayRanking.propTypes = {
    className: PropTypes.string,
    data: PropTypes.array.isRequired
};

export default TodayRanking;
